import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { OperazioneMassivaSearchForm } from '../models/operazioni-massive.model';
import { OperazioniMassiveService } from '../services/operazioni-massive.service';
import { OperazioneMassivaResponse, OperazioneMassivaTipo } from '../models/operazioni-massive-service.model';
import { Observable, of } from 'rxjs';

type OperationTypeList =  { id: OperazioneMassivaTipo, description: string};

@Component({
  selector: 'app-ricerca-operazioni-massive',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template:`
      <div class="card card-w-title">
      <h3>Ricerca Operazioni Massive</h3>
      <div class="advanced-search">
        <form [formGroup]="searchForm" (ngSubmit)="search()">
          <div class="grid">
            <div class="col-12">
              <label class="small-label" for="tipo">Tipo</label>
              <p-multiSelect formControlName="tipo" inputId="tipo" tooltipPosition="left" [style]="{'width': '420px'}"
                optionLabel="description" optionValue="id" [showClear]="true" placeholder="Seleziona il tipo di operazione"
                [options]="operationTypeList">
              </p-multiSelect>
            </div>

            <div class="col-12">
              <app-date-filter formControlName="dataOperazione" label="Data operazione"></app-date-filter>
            </div>

            <div class="col-12 md:col-6">
              <label class="small-label" for="registerId">Numero ordine nel registro</label>
              <p-inputNumber id="registerId" formControlName="registerId" mode="decimal" [useGrouping]="false"
                [style]="{'width': '420px'}" />
            </div>

            <div class="col-12 md:col-6">
              <label class="small-label" for="verbalId">Numero ordine di servizio</label>
              <input pInputText autocomplete="off" type="text" formControlName="verbalId" id="verbalId"
                [style]="{'width': '420px'}">
            </div>

            <div class="col-12 flex justify-content-end gap-2">
              <button pButton type="button" icon="fas fa-eraser" label="Pulisci" title="Pulisci"
                (click)="clearForm()"></button>
              <button pButton type="button" icon="fas fa-search" label="Cerca" title="Cerca" (click)="search()"></button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="card card-w-title">
      @if ( operations$ | async; as operations ) {
      <app-operazioni-massive-list [data]="operations"></app-operazioni-massive-list>
      }
    </div>
  `
})
export class RicercaOperazioniMassiveComponent {

  private readonly fb = inject(FormBuilder);
  private readonly operationService = inject(OperazioniMassiveService);

  public searchForm: FormGroup<OperazioneMassivaSearchForm>;
  public operations$ : Observable<OperazioneMassivaResponse[]> = of([]);

  public readonly operationTypeList : OperationTypeList[] = [
    {id: OperazioneMassivaTipo.Distruzione, description: 'Distruzione'},
    {id: OperazioneMassivaTipo.Declassifica, description: 'Declassifica'},
    {id: OperazioneMassivaTipo.Versamento, description: 'Versamento'}
  ]

  constructor() {
    this.searchForm = this.fb.group<OperazioneMassivaSearchForm>({
      tipo: new FormControl(null),
      dataOperazione: new FormControl(null),
      registerId: new FormControl(null),
      verbalId: new FormControl(null),
    });
  }

  public clearForm(): void {
    this.searchForm.reset();
  }

  public search(): void {
      const tipo = this.searchForm.value.tipo;
      const from : Date|null = this.searchForm.value.dataOperazione?this.searchForm.value.dataOperazione[0]:null;
      const to : Date|null = this.searchForm.value.dataOperazione?this.searchForm.value.dataOperazione[1]:null;

      const registerId : number|null = this.searchForm.value.registerId?this.searchForm.value.registerId:null;
      const verbalId : string|null = this.searchForm.value.verbalId?this.searchForm.value.verbalId:null;

      this.operations$ = this.operationService.getAll(tipo, from, to, registerId, verbalId);
  }
}
